export default __webpack_public_path__ + "static/media/cronos-cro-logo.ccf021cb.svg";